import { render, staticRenderFns } from "./BrandCreate.vue?vue&type=template&id=68397d5a&"
import script from "./BrandCreate.vue?vue&type=script&lang=ts&"
export * from "./BrandCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports